import clsx from "clsx";
import { Skeleton } from "@/components/ui/skeleton";
import { CommunicationMetricsChartsSkeleton } from "./CommunicationMetrics";

function MetricsCardSkeleton() {
  return (
    <div
      className={clsx(
        "bg-panel",
        "rounded-xl",
        "p-6",
        "border",
        "border-neutral",
        "overflow-hidden"
      )}
    >
      {/* Header row */}
      <div className={clsx("flex", "items-center", "justify-between", "mb-6")}>
        <Skeleton className="h-6 w-48" />
        <Skeleton className="h-4 w-20" />
      </div>

      {/* Channel pills */}
      <div className={clsx("flex", "gap-2", "mb-6")}>
        <Skeleton className="h-8 w-28 rounded-full" />
        <Skeleton className="h-8 w-16 rounded-full" />
        <Skeleton className="h-8 w-24 rounded-full" />
      </div>

      {/* Charts area */}
      <CommunicationMetricsChartsSkeleton />
    </div>
  );
}

function JumpInSectionSkeleton() {
  return (
    <div className={clsx("flex", "flex-col", "gap-4")}>
      <Skeleton className="h-5 w-44" />
      <div
        className={clsx(
          "grid",
          "grid-cols-1",
          "sm:grid-cols-2",
          "lg:grid-cols-4",
          "gap-4"
        )}
      >
        {[1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className={clsx(
              "bg-panel",
              "border",
              "border-neutral",
              "rounded-xl",
              "p-4",
              "flex",
              "flex-col",
              "gap-3"
            )}
          >
            <Skeleton className="h-10 w-10 rounded-lg" />
            <Skeleton className="h-4 w-3/4" />
            <Skeleton className="h-3 w-full" />
            <Skeleton className="h-3 w-5/6" />
          </div>
        ))}
      </div>
    </div>
  );
}

export default function DashboardSkeleton() {
  // No recommended-actions rail here: whether that section has anything to
  // show isn't known until detection finishes, so it animates in afterwards
  // rather than being promised by a skeleton.
  return (
    <div className={clsx("flex", "flex-col", "gap-8")}>
      <MetricsCardSkeleton />
      <JumpInSectionSkeleton />
      <JumpInSectionSkeleton />
    </div>
  );
}
